import React from 'react';
import { getNestedValue, formatString, safeDisplayValue } from './utils';

/**
 * InfoItem component - renders a single key-value row
 */
const InfoItem = ({ label, value }) => (
  <div
    className="flex justify-between items-center py-1.5 first:pt-0"
    style={{ borderBottom: '1px solid rgba(255,255,255,0.03)' }}
  >
    <span className="text-[12px] text-slate-400 font-bold">{label}</span>
    <span className="text-[13px] text-slate-100 font-bold">{value || '-'}</span>
  </div>
);

/**
 * InfoListWidget - Renders a list of key-value pairs
 * 
 * Config structure:
 * {
 *   items: [
 *     { label: "관리 번호", dataKey: "machine_manage_code" },
 *     { label: "제조사 / 모델", dataKey: "machine_manufacturer", format: "{machine_manufacturer} / {machine_model_name}" }
 *   ]
 * }
 */
// Utility to resolve value from data based on item config
const resolveItemValue = (item, data) => {
  if (item.format) {
    return formatString(item.format, data);
  }
  
  // New Dynamic Binding Pattern
  if (item.target_table && item.target_column) {
    const key = `${item.target_table}.${item.target_column}`;
    return data[key];
  }

  // Legacy Pattern
  return getNestedValue(data, item.dataKey);
};

export default function InfoListWidget({ config, data }) {
  // Support both 'items' from config object or direct 'items' array (from new API structure)
  const items = config?.items || config || [];

  if (!Array.isArray(items) || items.length === 0) return null;

  return (
    <div>
      {config.title && (
        <div className="flex items-center justify-between px-1 mb-2">
          <span className="text-[12px] text-slate-400 font-bold">{config.title}</span>
        </div>
      )}
      <div className="space-y-0.5">
      {items.map((item, idx) => {
        const rawValue = resolveItemValue(item, data);

        return (
          <InfoItem 
            key={idx} 
            label={item.label} 
            value={safeDisplayValue(rawValue)} 
          />
        );
      })}
      </div>
    </div>
  );
}
